window.Products.HomeDecor.StainlessSteelWaterBottle = function () {}
window.Products.HomeDecor.StainlessSteelWaterBottle.inherits(window.Products.HomeDecor.HomeDecor)